import apiRequest from "utils/ApiRequest/apiRequest.js";
import { useToasts } from "react-toast-notifications";
import { useUser } from "contexts/userContext/userContext";
import { useContent } from "contexts/contentContext/contentContext";
import { useState } from "react";

const useCancelSubscriptionRequest = ({
  setUserIsAutoRenew,
  cancelType,
}: {
  setUserIsAutoRenew: (value: boolean) => void;
  cancelType: string;
}) => {
  const { addToast } = useToasts();
  const { setUserBillingDetailsDataProp } = useUser();
  const { getTextByKey } = useContent();

  const [isCancellingSubscription, setIsCancellingSubscription] =
    useState(false);

  const createCancelSubscriptionSurvey = async (body) => {
    setIsCancellingSubscription(true);
    const response = await apiRequest(
      "Users",
      "CreateCancelSubscriptionSurvey",
      body,
      "POST"
    );
    if (response.status === "success" && response.data) {
      setUserIsAutoRenew(false);
      setUserBillingDetailsDataProp({
        key: "endDate",
        value: response.data?.ExpirationDate,
      });
      if (cancelType === "cancel-immediately") {
        setUserBillingDetailsDataProp({
          key: "cancelType",
          value: "cancel-immediately",
        });
        setUserBillingDetailsDataProp({
          key: "auto_renew",
          value: false,
        });
      }
    } else {
      const textToShow = response.data
        ? response.data
        : "cancel-subscription-global-error";
      addToast(getTextByKey(textToShow), {
        appearance: "error",
      });
    }
    setIsCancellingSubscription(false);
  };

  return { createCancelSubscriptionSurvey, isCancellingSubscription };
};

export default useCancelSubscriptionRequest;
